export const TestIds = {
  colorUnderlay: 'colorUnderlay',
  mediaPadding: 'mediaPadding',
} as const;
